module.exports = __webpack_public_path__ + "static/media/barbarians.b1a84b9e.jpg";